
import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { context } from '@posco/posco-shared';
import { Login, SignUp, PortalLayout } from "./layout";
import { Routes as SampleRoutes } from "./sample";
import  { Routes as O10g015460 }  from './o10g015460';
import None404 from "./none404";
import None401 from "./none401";
import Viewers from "./Viewers";
import LogOutUser from "./logOutUser";
import O10g014111Container from "./o10g014111/container/O10g014111Container";


const contextPath = location.host.includes("localhost") ? "/o10t01-front" : context.path();

const Routes = () => {
  console.log('contextPath => ', contextPath);
  return (
    <BrowserRouter basename={contextPath}>
      <Viewers>
        <Switch>
          <Route
            path={"/o10g014111"}
            render={(() => (
              <O10g014111Container />
            ))}
          />
          <Route
            path={"/signup"}
            render={(() => (
              <SignUp />
            ))}
          />
          <Route
            path={"/login"}
            render={(() => (
              <O10g015460 />
            ))}
          />
          {/* 테스트용 로그인(기존 로그인)*/}
          <Route
            path={"/o10g015460"}
            render={(() => (
              <Login />
            ))}
          />
          <Route
            path={"/o100101010"}
            render={(() => (
              <SampleRoutes/>
            ))}
          />
          <Route
            path={"/404"}
            render={(() => (
              <None404/>
            ))}
          />
          <Route
            path={"/401"}
            render={(() => (
              <None401/>
            ))}
          />
          <Route
            path={"/logOutUser"}
            render={(() => (
              <LogOutUser/>
            ))}
          />
          {/* 사외로그인*/}
          {/*<Route*/}
          {/*  path={"/o10g015460"}*/}
          {/*  render={(() => (*/}
          {/*    <O10g015460 />*/}
          {/*  ))}*/}
          {/*/>*/}
          <Route
            path={"/"}
            // render={(() => (
            //   <PortalLayout />
            // ))}
            //this.props.history.listen 쓰기위해 render에서 component로 변경
            component={PortalLayout}
            />
        </Switch>
      </Viewers>
    </BrowserRouter>
  );
}

export default Routes;
